
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Pin = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect x="-0.2" y="-0.2" width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M21.7,7.4a3.7,3.7,0,0,0-1-2.3L16.6,1,7.7,9.9H7.2a7.1,7.1,0,0,0-4.9,2l4.4,4.4L1.8,21.2l1.1,1.1,4.9-4.9,4.3,4.3a7.2,7.2,0,0,0,2-5.3l6.6-6.7A3.3,3.3,0,0,0,21.7,7.4Zm-9.8,12L4.6,12.1a4.8,4.8,0,0,1,2.6-.7A5.5,5.5,0,0,1,11,13,5.2,5.2,0,0,1,11.9,19.4ZM19.7,8.7l-6,5.9a6.3,6.3,0,0,0-1.6-2.7,8,8,0,0,0-2.6-1.6l7.1-7.1,3.1,3a1.8,1.8,0,0,1,.5,1.2A1.9,1.9,0,0,1,19.7,8.7Z"></path>
        </g>
      </g>
    </IconBase>);
};

Pin.defaultProps = {
  title: 'Pin',
};

export default Pin;
